import React, { useEffect, useState } from 'react';
import {
    Box, Button, FormControl, FormLabel, FormErrorMessage,
    Input, Textarea,
    Text
} from '@chakra-ui/react';
import Select from 'react-select';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { fetchWrapper } from '../../helpers';
import { toast } from 'react-toastify';
import axios from 'axios';
import { InputText } from '../../components/form';

const validationSchema = Yup.object({
    phone: Yup.string()
        .required('Phone number is required'),
    parser: Yup.string().required('Parser is required'),
    message: Yup.string().required('Message is required'),
    preferredChannel: Yup.string().required('Preferred channel is required'),
});

const ParserApi = () => {
    const [templateOptions, setTemplateOptions] = useState([]);
    const [channelOptions, setChannelOptions] = useState([]);
    const [parser, setParser] = useState({});
    const [loading, setLoading] = useState(false);

    const TemplateList = async () => {
        try {
            const url = `${process.env.REACT_APP_API_URL}/template-parser/list?customer_id=${process.env.REACT_APP_CUSTOMER_ID}`;
            const data = await fetchWrapper.get(url);
            const transformed = data.data.map((item) => ({
                label: item?.TemplateMessage?.name,
                value: item?.parser_id,
                ...item,
            }));
            setTemplateOptions(transformed);
        } catch (error) {
            console.error('Error fetching templates:', error);
            toast('Error fetching templates', { type: 'error' });
        }
    };

    const ChannelList = async () => {
        try {
            const url = `${process.env.REACT_APP_API_URL}/channel/list`;
            const data = await fetchWrapper.get(url);
            let transformedData = data.data.map((item) => ({
                label: item?.name,
                value: item?.name
            }));
            setChannelOptions([...transformedData, { label: "Smart Routing", value: "smart" }, { label: "Custom Routing", value: "custom" }]);
        } catch (error) {
            console.error('Error fetching channels:', error);
        }
    };

    useEffect(() => {
        TemplateList();
        ChannelList();
    }, []);

    const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {
        const payload_without_custom = {
            to: values.phone,
            message: values.message,
            parser_id: values.parser,
            payload_type: "text",
            email: values.email || '', // Optional email field
            // trans_type: parser?.TemplateMessage?.MessageTemplateType?.message_type_id,
            preferred_channel: values.preferredChannel
        };
        const payload_with_custom = {
            to: values.phone,
            message: values.message,
            parser_id: values.parser,
            payload_type: "text",
             email: values.email || '', // Optional email field
            // trans_type: parser?.TemplateMessage?.MessageTemplateType?.message_type_id,
            // preferred_channel: values.preferredChannel
        };

        const payload = (values.preferredChannel === "custom" || values.preferredChannel === 'smart') ? payload_with_custom : payload_without_custom;
        try {
            setLoading(true);
            let url = `${process.env.REACT_APP_SEND_API_URL}/v2/message`;

            let url_api_key = `${process.env.REACT_APP_API_URL}/customer/by-id?id=${process.env.REACT_APP_CUSTOMER_ID}`;
            let res = await fetchWrapper.get(url_api_key);
            if (res.status) {
                let config = {
                    method: 'post',
                    maxBodyLength: Infinity,
                    url: url,
                    headers: {
                        'Content-Type': 'application/json',
                        'x-api-key': res?.data?.api_key,
                        'host': "xnotify.ai"
                    },
                    data: payload
                };
                await axios.post(url, payload, config);
                toast('Message has been sent', { type: 'success' });

            } else {
                toast.error('Some thing went wrong', { type: 'error' });

            }

            // resetForm();
        } catch (error) {
            toast(error.message || 'Failed to send message', { type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='sms_body_section'>
            <Formik
                initialValues={{
                    phone: '',
                    parser: '',
                    message: '',
                    preferredChannel: '',
                }}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {({ isSubmitting, setFieldValue, values, errors, touched }) => (
                    <Form>
                        <Box style={{ width: "100%" }} >
                            <Box>
                                <Text fontSize="32px" fontWeight="300" color="#000000" my="0px" fontFamily="'Open Sans', sans-serif">
                                    Send Message
                                </Text>
                            </Box>
                            {/* Phone Number */}
                            <Field name="phone">
                                {({ field, form }) => (
                                    <FormControl isInvalid={form.errors.phone && form.touched.phone} mb={4} isRequired>
                                        <FormLabel>Phone Number</FormLabel>
                                        <Input {...field} placeholder="Enter phone number" />
                                        <FormErrorMessage>{form.errors.phone}</FormErrorMessage>
                                    </FormControl>
                                )}
                            </Field>

                            {/* Parser Dropdown (react-select) */}
                            <Field name="parser">
                                {({ form }) => (
                                    <FormControl isInvalid={form.errors.parser && form.touched.parser} mb={4} isRequired>
                                        <FormLabel>Parser</FormLabel>
                                        <Select
                                            options={templateOptions}
                                            value={templateOptions?.find(option => option?.value === values?.parser)}
                                            onChange={(option) => {
                                                setFieldValue('parser', option.value);
                                                setFieldValue('message', option.message);
                                                setParser(option) // auto-fill message
                                            }}
                                            placeholder="Select Template"
                                        />
                                        <FormErrorMessage>{form.errors.parser}</FormErrorMessage>
                                    </FormControl>
                                )}
                            </Field>



                            {/* Message Textarea - FIXED with {...field} */}
                            <Field name="message">
                                {({ field, form }) => (
                                    <FormControl isInvalid={form.errors.message && form.touched.message} mb={4} isRequired>
                                        <FormLabel>Message</FormLabel>
                                        <Textarea {...field} placeholder="Enter message" rows={5} />
                                        <FormErrorMessage>{form.errors.message}</FormErrorMessage>
                                    </FormControl>
                                )}
                            </Field>

                            {/* Preferred Channel (react-select) */}
                            <Field name="preferredChannel">
                                {({ form }) => (
                                    <FormControl isInvalid={form.errors.preferredChannel && form.touched.preferredChannel} mb={4} isRequired>
                                        <FormLabel>Preferred Channel</FormLabel>
                                        <Select
                                            options={channelOptions}
                                            value={channelOptions?.find(option => option?.value === values?.preferredChannel)}
                                            onChange={(option) => setFieldValue('preferredChannel', option.value)}
                                            placeholder="Select Channel"
                                        />
                                        <FormErrorMessage>{form.errors.preferredChannel}</FormErrorMessage>
                                    </FormControl>
                                )}
                            </Field>
                            <Box mb="10px">
                                <InputText
                                    name="email"
                                    title="E-Mail (Optional)"
                                    placeholder="Please Enter Email ID"
                                />
                            </Box>
                            {/* Submit Button */}
                            <Button
                                py="10px"
                                px="25px"
                                color="#fff"
                                bg="#2563eb"
                                fontSize="14px"
                                fontWeight="500"
                                fontFamily="'Open Sans', sans-serif"
                                mb={4}
                                style={{ width: "100%" }}
                                type="submit"
                                isLoading={isSubmitting || loading}
                                mt={4}
                            >
                                Send Test Message
                            </Button>
                        </Box>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default ParserApi;